import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StateUserParams } from "../types/users/usersParams";

interface UsersInitialStateParams {
    isLoading: boolean;
    getAllUsers: StateUserParams[];
    searchUser: StateUserParams[];
    currentPage: number;
    numberOfPages: number;
    totalNumber: number;
    singleUser: StateUserParams | null;
    updateUser: StateUserParams[] | null;
    deleteUser: StateUserParams[] | null;
}

const initialState: UsersInitialStateParams = {
    isLoading: true,
    getAllUsers: [],
    searchUser: [],
    currentPage: 1,
    numberOfPages: 0,
    totalNumber: 0,
    singleUser: null,
    updateUser: null,
    deleteUser: null,
}

const usersSlice = createSlice({
    name: 'USERS',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setUsers: (state, action: PayloadAction<{
            data: StateUserParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.getAllUsers         = action.payload.data;
            state.currentPage         = action.payload.currentPage;
            state.numberOfPages       = action.payload.numberOfPages;
            state.totalNumber         = action.payload.totalNumber;
        },
        setSingleUser: (state, action: PayloadAction<StateUserParams>) => {
            state.singleUser          = action.payload;
        },
        setUsersSearch: (state, action: PayloadAction<{
            data: StateUserParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.searchUser          = action.payload.data;
            state.currentPage         = action.payload.currentPage
            state.numberOfPages       = action.payload.numberOfPages
            state.totalNumber         = action.payload.totalNumber
        },
        setUpdateUser: (state, action: PayloadAction<StateUserParams>) => {
            state.updateUser          = state.getAllUsers.map((result) =>
                result._id === action.payload._id ? action.payload : result
            );
        },
        setDeleteUser: (state, action: PayloadAction<string>) => {
            state.deleteUser = state.getAllUsers.filter((result) => result._id !== action.payload);
        }
    }
});

export const { startLoading, endLoading, setUsers, setSingleUser, setUsersSearch, setUpdateUser, setDeleteUser } = usersSlice.actions
export default usersSlice.reducer
